// @flow
import { connect } from 'react-redux';

import MyTeamHome from 'components/profile/DashboardHome/MyTeamHome';
import type { StateProps } from 'components/profile/DashboardHome/MyTeamHome';
import type { StateType } from 'types/Actions';

export default connect(
  (state: StateType): StateProps => ({
    userPref: state.userState.userPref,
  }),
)(MyTeamHome);